import { render, staticRenderFns } from "./ProjectSingleSelector.vue?vue&type=template&id=bf33357a&scoped=true&"
import script from "./ProjectSingleSelector.vue?vue&type=script&lang=js&"
export * from "./ProjectSingleSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf33357a",
  null
  
)

export default component.exports